import dayjs from 'dayjs'

export function isEndTimeAfterStartTime(startTime: string, endTime: string): boolean {
    const start = dayjs(startTime, 'HH:mm', true)
    const end = dayjs(endTime, 'HH:mm', true)
    if (!start.isValid() || !end.isValid()) return false
    return end.isAfter(start)
}
